(function (){
  setupToggleDescription();
  national();
  startCountdown('.countdown_box[data-countdown]');
})();
new PerformanceObserver((entryList) => {
  for (const entry of entryList.getEntriesByName('first-contentful-paint')) {
    console.log('FCP candidate:', entry.startTime, entry);
  }
}).observe({type: 'paint', buffered: true});
/**
 * 展开收起功能函数
 */
function setupToggleDescription(collapsedClass = 'collapsed', tableClass = 'height244') {
  const boxes = document.querySelectorAll('.Copywriting0410, .TableBox0410');
  const buttons = document.querySelectorAll('.toggle-button');

  boxes.forEach((box, index) => {
    const button = buttons[index];
    if (!box || !button) return;

    // 判断是否是表格
    const isTable = box.classList.contains('TableBox0410');

    button.addEventListener('click', function () {
      if (isTable) {
        // 表格类用 height155
        box.classList.toggle(tableClass);
      } else {
        // 普通文本用 collapsed
        box.classList.toggle(collapsedClass);
      }

      const isCollapsed = isTable
        ? box.classList.contains(tableClass)
        : box.classList.contains(collapsedClass);

      button.textContent = isCollapsed ? 'Read more +' : 'Read less -';
    });
  });
}
/**
 * 国旗功能函数
 */
function national(){
  var contry_USAandGE = document.querySelector('.contry_USAandGE');
  var contry_box = document.querySelector('.contry_box');
  var contry_USAandGEList = document.querySelector(
    '.contry_USAandGEList'
  );
  contry_USAandGE.addEventListener('mouseenter', function () {
    contry_USAandGEList.style.display = 'block';
  });
  contry_box.addEventListener('mouseleave', function () {
    contry_USAandGEList.style.display = 'none';
  });
}
/**
 * 电话功能
 */
const box = document.getElementById('box1');
const popupBox = document.getElementById('popupBox12');
const closeBtn12 = document.getElementById('closeBtn12');
box.addEventListener('click', function() {
  popupBox.style.display = 'block';
});
closeBtn12.addEventListener('click', function() {
  popupBox.style.display = 'none';
});
/**
 * 倒计时函数
 */
function startCountdown(selector) {
  function pad(num) {
    return num.toString().padStart(2, '0');
  }

  const boxes = document.querySelectorAll(selector);
  if (!boxes.length) return;

  boxes.forEach(box => {
    const endTimeStr = box.getAttribute('data-countdown');
    const endTime = new Date(endTimeStr.replace(/-/g, '/')); // Safari兼容处理

    function updateCountdown() {
      const now = new Date();
      const diff = endTime - now;

      if (diff <= 0) {
        box.querySelector('.cd-days').textContent = '00';
        box.querySelector('.cd-hours').textContent = '00';
        box.querySelector('.cd-minutes').textContent = '00';
        box.querySelector('.cd-seconds').textContent = '00';
        clearInterval(timer);
        return;
      }

      const seconds = Math.floor((diff / 1000) % 60);
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const hours = Math.floor((diff / 1000 / 60 / 60) % 24);
      const days = Math.floor(diff / 1000 / 60 / 60 / 24);

      box.querySelector('.cd-days').textContent = pad(days);
      box.querySelector('.cd-hours').textContent = pad(hours);
      box.querySelector('.cd-minutes').textContent = pad(minutes);
      box.querySelector('.cd-seconds').textContent = pad(seconds);
    }

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
  });
}
/**
 * 变体展示元字段函数
 */
(() => {
  if (window.__variantInfoInlineLoaded) return;
  window.__variantInfoInlineLoaded = true;
  const ACTIVE_CLASS = 'is-active';
  const SELECTOR = 'variant-selects.variant-selectsBox';
  const parseJsonSafe = (text) => {
    try { return JSON.parse(text); } catch { return null; }
  };
  const getInfoMap = (vs) => {
    if (vs.__variantInfoMap) return vs.__variantInfoMap;
    const mapEl = vs.querySelector('[data-variant-info-map]');
    const obj = mapEl ? parseJsonSafe(mapEl.textContent || '{}') : {};
    vs.__variantInfoMap = obj && typeof obj === 'object' ? obj : {};
    return vs.__variantInfoMap;
  };
  const readVariantId = (vs) => {
    const selectedEl = vs.querySelector('[data-selected-variant]');
    const selectedObj = selectedEl ? parseJsonSafe(selectedEl.textContent || '') : null;
    if (selectedObj?.id) return String(selectedObj.id);
    const formId = vs.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    return idInput?.value ? String(idInput.value) : null;
  };
  const closeSlot = (slot) => {
    if (!slot) return;
    slot.style.maxHeight = (slot.scrollHeight || 0) + 'px';
    requestAnimationFrame(() => {
      slot.classList.remove(ACTIVE_CLASS);
      slot.style.maxHeight = '0px';
    });
  };
  const openSlot = (slot, html) => {
    if (!slot) return;
    slot.innerHTML = `<div class="variant-info-inline__inner rte">${html}</div>`;
    slot.style.maxHeight = '0px';
    requestAnimationFrame(() => {
      slot.classList.add(ACTIVE_CLASS);
      slot.style.maxHeight = slot.scrollHeight + 'px';
    });
  };
  const getSlotForInputId = (vs, inputId) => {
    if (!inputId) return null;
    return vs.querySelector(`[data-variant-info-slot][data-for-input="${inputId}"]`);
  };
  const findCheckedRadioId = (vs) => {
    const checked = vs.querySelectorAll('input[type="radio"]:checked');
    return checked.length ? (checked[checked.length - 1].id || null) : null;
  };
  const update = (vs, { inputId = null, variantId = null, retry = 0 } = {}) => {
    const resolvedVariantId = variantId || readVariantId(vs);
    if (!resolvedVariantId) {
      if (retry < 12) setTimeout(() => update(vs, { inputId, variantId, retry: retry + 1 }), 50);
      return;
    }
    const html = getInfoMap(vs)[resolvedVariantId] || null;
    const resolvedInputId = inputId || vs.__variantInfoLastInputId || findCheckedRadioId(vs);
    const slot = getSlotForInputId(vs, resolvedInputId);
    const activeSlot = vs.__variantInfoActiveSlot || null;
    if (!html || !slot) {
      closeSlot(activeSlot);
      vs.__variantInfoActiveSlot = null;
      return;
    }
    if (activeSlot && activeSlot !== slot) closeSlot(activeSlot);
    openSlot(slot, html);
    vs.__variantInfoActiveSlot = slot;
  };
  const scheduleUpdate = (vs, payload = {}) => {
    if (payload.inputId) vs.__variantInfoLastInputId = payload.inputId;
    clearTimeout(vs.__vinfoT0);
    clearTimeout(vs.__vinfoT1);
    clearTimeout(vs.__vinfoT2);
    vs.__vinfoT0 = setTimeout(() => update(vs, payload), 0);
    vs.__vinfoT1 = setTimeout(() => update(vs, payload), 120);
    vs.__vinfoT2 = setTimeout(() => update(vs, payload), 260);
  };
  const initOne = (vs) => {
    if (vs.__variantInfoInited) return;
    vs.__variantInfoInited = true;
    vs.addEventListener('change', (e) => {
      const t = e.target;
      if (t?.matches?.('input[type="radio"]')) {
        vs.__variantInfoLastInputId = t.id;
      }
      // 为了避免“先显示旧的再被替换”，这里先收起，等待 variantChange 后再展开
      closeSlot(vs.__variantInfoActiveSlot);
    });
    // 初次进入
    scheduleUpdate(vs, {});
  };
  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initOne);
  };
  const updateAll = () => {
    init(document);
    document.querySelectorAll(SELECTOR).forEach((vs) => scheduleUpdate(vs, {}));
  };
  const subscribeFoxTheme = () => {
    const pubsub = window.FoxTheme?.pubsub;
    if (!pubsub?.subscribe) return false;
    // 变体真正更新完成（DOM 已被替换/更新）后再展开
    pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, () => {
      updateAll();
    });
    return true;
  };
  const bootstrap = () => {
    updateAll();
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (subscribeFoxTheme() || tries > 40) clearInterval(timer);
    }, 50);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', (e) => updateAll());
  // 兜底：有些地方只派发这个
  document.addEventListener('variant:changed', () => updateAll());
  // 兜底：quick view / viewTransition 插入新 DOM
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n?.nodeType !== 1) continue;
        if (n.matches?.(SELECTOR)) initOne(n);
        else if (n.querySelectorAll) init(n);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
